import { gettext } from '@eventbrite/legacy-infra.i18n';
import React from 'react';
import styles from './RefundDisplay.module.scss';

export const RefundDisplay = (props: { helpCenterLanguage: string }) => {
    const { helpCenterLanguage } = props;
    const refundUrl = `/help/${helpCenterLanguage}/articles/721549/can-i-get-a-refund/`;

    return (
        <p className={styles.refundText} data-testid="reason_refund-radio">
            {gettext(
                'Would like to request a refund? Learn more about how to request a refund',
            )}{' '}
            <a
                href={refundUrl}
                rel="noopener noreferrer"
                target="_blank"
                title={gettext('Link to Requesting a Refund').toString()}
            >
                {gettext('here')}
            </a>
            .
        </p>
    );
};
